import React, { Component } from "react";
import PropTypes from 'prop-types';
import styled from "styled-components";
import { Column, Table, AutoSizer } from "react-virtualized";
import "react-virtualized/styles.css";
import "css/index.css";

export default class ManagedTable extends Component {

    static propTypes = {
        contentList: PropTypes.array,
        title: PropTypes.string
    }

    static defaultProps = {
        contentList: [],
        title: ""
    }

    render() {
        const { contentList, title } = this.props
        const head = contentList[0]
        const columnStructure = Object.keys(head)
        return (
        <Wrapper>
            <Title>{title.toUpperCase()}</Title>
            <AutoSizer disableHeight>
              {({ width }) => (
                <Table
                  width={width}
                  height={250}
                  headerHeight={40}
                  rowHeight={50}
                  rowCount={contentList.length}
                  rowGetter={({ index }) => contentList[index]}
                  rowClassName="border-top-table-analytic"
                  headerClassName="header-table-analytic"
                  
                >
                    {columnStructure.map((name, index) =>{
                        return (
                            <Column 
                                key={index}
                                dataKey={name}
                                label={name}
                                width={520}
                                rowHeight={50}
                            />
                        )
                    })}   
                </Table>
              )}
            </AutoSizer>
        </Wrapper>);
    }
    // _rowClassName({index}) {
    //     if (index < 0) {
    //       return styles.headerRow;
    //     } else {
    //       return index % 2 === 0 ? styles.evenRow : styles.oddRow;
    //     }
    //   }

}

const Wrapper = styled.section`
    flex: 1;
    height: 300px;
    color: #59585b;
    text-align: center;
    margin: 10px;
`;

const Title = styled.div`
    font-weight: bold;
    color: #59585b;
    margin: 10px 0;
    text-align: left;
`;



// WEBPACK FOOTER //
// ./src/module-analytics/components/ManagedTable.js